
export { gtmAffiliateProductClick } from "./gtmAffiliate"